import { Button as HeadlessUIButton } from '@flywire/headlessui-tailwindcss';
import type React from 'react';
import type { ComponentProps } from 'react';
import { cx } from 'utils/cx/cx';

interface ButtonProps extends ComponentProps<typeof HeadlessUIButton> {
  children?: React.ReactNode;
  labelClassName?: string;
}

const Button = ({
  children,
  dangerouslySetInnerHTML,
  labelClassName,
  ...props
}: ButtonProps) => {
  if (dangerouslySetInnerHTML) {
    return (
      <HeadlessUIButton {...props}>
        <span
          className={cx('text-[13px] font-medium uppercase', labelClassName)}
          dangerouslySetInnerHTML={dangerouslySetInnerHTML}
        />
      </HeadlessUIButton>
    );
  }

  return (
    <HeadlessUIButton {...props}>
      <span className={cx('text-[13px] font-medium uppercase', labelClassName)}>
        {children || 'Submit'}
      </span>
    </HeadlessUIButton>
  );
};

export { Button };
